import { createContext, useContext } from "react";
import { RootStore } from "@web/stores";

export const RootStoreContext = createContext({} as RootStore);

export const useStores = () => useContext(RootStoreContext);
